export enum UploadLayout {
  LIVE_GIF = "cont",
  GIF = "gif",
  REBOUND = "rebound",
  VIDEO = "video",
  ONE_BY_ONE = "1x1",
  ONE_BY_TWO = "1x2",
  ONE_BY_THREE = "1x3",
  ONE_BY_FOUR = "1x4",
  ONE_AND_TWO = "1&2",
  TWO_BY_ONE = "2x1",
  TWO_BY_TWO = "2x2",
  TWO_BY_THREE = "2x3",
  TWO_AND_THREE = "2&3",
}